import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';

import { 勘定科目ListItemResponse } from '@/openapi/user';

import 勘定科目Mixin from '@/entries/user/mixins/勘定科目Mixin';

export default mixins(勘定科目Mixin).extend({
  name: 'C固定資産科目Select',

  props: {
    勘定科目s: {
      type: Array as PropType<勘定科目ListItemResponse[]>,
      default: () => [],
    },
    pk: {
      type: Number,
    },
    includesEmpty: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    filtered勘定科目s(): 勘定科目ListItemResponse[] {
      return this.filter固定資産科目(this.勘定科目s);
    },
    selected: {
      get(): number | undefined {
        const filtered = this.filtered勘定科目s;
        if (filtered.length === 0) return undefined;

        if (this.includesEmpty) return this.pk;
        if (filtered.some((勘) => 勘.pk === this.pk)) return this.pk;

        // pkがfiltered勘定科目sに存在しない場合は最初の項目を設定する
        const pk = filtered[0].pk;
        this.$emit('update:pk', pk);
        return pk;
      },
      set(pk: number): void {
        this.$emit('update:pk', pk);
      },
    },
  },
});
